const colors = {
  background: "rgb(255, 255, 255)",

  text_primary: "rgb(55, 55, 55)",
  text_secondary: "rgb(105, 105, 105)",
  text_accent: "rgb(193, 127, 26)",

  header_bg: "rgb(255, 255, 255)",
  header_accent: "rgba(219, 178, 96, 0.5)",

  border: "rgb(150, 150, 150)",
  border_hover_primary: "rgb(224, 213, 202)",
  border_hover_secondary: "rgb(175, 175, 175)",

  error: "rgb(144, 37, 37)",

  progress: "rgb(166, 166, 166)",
  progress_filled: "rgb(0, 0, 0)",

  particles_primary: "rgb(205, 205, 205)",
  particles_secondary: "rgb(219, 178, 96)",
  line_primary: "rgb(195, 195, 195)",
  line_secondary: "rgb(235, 235, 235)",
  line_transition: "rgb(247, 229, 193)",

  preview_button_primary: "rgb(225, 225, 225)",
  preview_button_secondary: "rgb(175, 175, 175)",
  preview_button_tertiary: "rgb(100, 100, 100)",
  preview_button_active: "rgb(219, 178, 96)",

  cursor_circle: "rgba(0, 0, 0, .5)",
  cursor_caret: "rgba(0, 0, 0)",
};

export default colors;
